import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import {useStatusUpdates} from '../../state-providers/status-updates/status-updates-context'
import {
  NEW_STATUS_UPDATE_ID,
  useStatusUpdatesEditorState,
} from '../../state-providers/status-updates/status-updates-editor-state-context'
import {StatusUpdatesResources} from '../../strings'
import {StatusUpdateEditor} from './status-update-editor'
import {StatusUpdateItem} from './status-update-item'
import styles from './status-updates.module.css'
import {StatusUpdatesHeader} from './status-updates-header'

export const StatusUpdates = memo(function SidePanelMemexStatusUpdates() {
  const {memexStatusItems, isLoading} = useStatusUpdates()
  const {statusUpdateDrafts} = useStatusUpdatesEditorState()

  const newStatusUpdateDraft = statusUpdateDrafts[NEW_STATUS_UPDATE_ID]

  // The existence of a draft implies that the item is currently being added.
  const isAdding = !!newStatusUpdateDraft

  return (
    <div {...testIdProps('status-updates-container')} className={styles.container}>
      {isAdding && newStatusUpdateDraft ? (
        <div {...testIdProps('status-updates-create-container')} className={styles.createForm}>
          <h3 className={styles.createTitle}>{StatusUpdatesResources.addUpdateTitle}</h3>

          <StatusUpdateEditor statusUpdate={newStatusUpdateDraft} />
        </div>
      ) : (
        <StatusUpdatesHeader />
      )}
      {isLoading ? (
        <LoadingSkeleton variant="rounded" height="md" className={styles.loadingSkeleton} />
      ) : (
        <div aria-label="Status updates" role="list" className={styles.statusList}>
          {memexStatusItems.map(statusUpdate => (
            <StatusUpdateItem key={statusUpdate.id} status={statusUpdate} />
          ))}
        </div>
      )}
    </div>
  )
})
